import React from 'react'
import {
  Admin,
  Resource,
  CustomRoutes,
  localStorageStore,
  StoreContextProvider,
} from 'react-admin'
import { Route } from 'react-router-dom'
import AdminInvitation from './pages/AdminInvitation'

import { Dashboard } from './Dashboard'
import { Login } from './Login'

import { UserShow, UserList } from './resources/users'
import { ProductShow, ProductList, ProductCreate, ProductEdit } from './resources/products'
import { OrderShow, OrderList } from './resources/orders'

// https://mui.com/material-ui/material-icons/?theme=Outlined&query=report
import UserIcon from '@mui/icons-material/Group'
import ProductIcon from '@mui/icons-material/Inventory'
import OrderIcon from '@mui/icons-material/ShoppingCart'

import { authProvider, buildResourcePermissions } from './authProvider'
import { dataProvider } from './dataProvider'

import MyLayout from './layout/Layout'
import { ProfileEdit } from './pages/profile'
import { customDarkTheme, customLightTheme, logInBackgroundImage } from './theme/myCustomTheme'

const resources = [
  <Resource
    name="users"
    list={UserList}
    show={UserShow}
    recordRepresentation="email"
    icon={UserIcon}
    options={{ label: 'Users' }}
  />,
  <Resource
    name="products"
    list={ProductList}
    edit={ProductEdit}
    create={ProductCreate}
    show={ProductShow}
    recordRepresentation="title"
    icon={ProductIcon}
    options={{ label: 'Products' }}
  />,
  <Resource
    name="orders"
    list={OrderList}
    show={OrderShow}
    recordRepresentation="userId"
    icon={OrderIcon}
    options={{ label: 'Orders' }}
  />,
]

const filterResources = () => {
  const resourcesMap = buildResourcePermissions()
  const resourceNames = Object.keys(resourcesMap)

  return resources
    .filter((r) => resourceNames.includes(r.props.name))
    .map((resource) => {
      const resourceName = resource.props.name
      const permissions = resourcesMap[resourceName]

      const newProps = {
        name: resource.props.name,
        recordRepresentation: resource.props.recordRepresentation,
        icon: resource.props.icon,
        options: resource.props.options,
      }

      if (permissions.isRead) {
        if (resource.props.list) {
          newProps.list =
            typeof resource.props.list === 'function'
              ? resource.props.list({
                  isEdit: permissions.isEdit || false,
                  isDelete: permissions.isDelete || false,
                  isCreate: permissions.isCreate || false,
                })
              : resource.props.list
        } else {
          newProps.list = undefined
        }
        if (resource.props.show) {
          newProps.show = resource.props.show
        } else {
          newProps.show = undefined
        }
      } else {
        newProps.list = undefined
        newProps.show = undefined
      }

      if (permissions.isEdit && resource.props.edit) {
        newProps.edit = resource.props.edit
      } else {
        newProps.edit = undefined
      }

      if (permissions.isCreate && resource.props.create) {
        newProps.create = resource.props.create
      } else {
        newProps.create = undefined
      }

      return React.cloneElement(resource, newProps)
    })
}

const store = localStorageStore(undefined, 'publish-kit-admin')

const App = () => (
  <Admin
    loginPage={
      <Login
        style={{
          backgroundImage: logInBackgroundImage,
        }}
      />
    }
    dataProvider={dataProvider}
    authProvider={authProvider}
    store={store}
    dashboard={Dashboard}
    layout={MyLayout}
    theme={customLightTheme}
    darkTheme={customDarkTheme}
    defaultTheme="light"
  >
    <CustomRoutes>
      <Route key="my-profile" path="/my-profile" element={<ProfileEdit />} />
    </CustomRoutes>
    {filterResources}

    <CustomRoutes noLayout disableAuthentication>
      <Route key="admin-invitation" path="/admin-invitation" element={<AdminInvitation />} />
    </CustomRoutes>
  </Admin>
)

const AppWrapper = () => (
  <StoreContextProvider value={store}>
    <App />
  </StoreContextProvider>
)

export default AppWrapper
